/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// Utils
import { isEmpty } from 'lodash';

// Components
import ConditionRule from 'shared/ui/components/form-components/targeting/ConditionRule.vue';

const __vue_script__ = {
    name: 'PersonTarget',

    components: { ConditionRule },

    props: {
        eventId: {
            type: String,
            required: true
        },

        value: {
            type: Array,
            default: () => []
        },

        showActions: {
            type: Boolean,
            default: false
        },

        fieldKinds: {
            type: Array,
            default: undefined,
        },

        additionalFields: {
            type: Array,
            default: () => [],
        }
    },

    data() {
        return {
            fields: [],
            metadata: null,
            innerValue: []
        };
    },

    watch: {
        value: {
            immediate: true,
            handler() {
                this.innerValue = this.unnormalizeTargetConfig(this.value || []);
            }
        }
    },

    async created() {
        try {
            const event = await this.$services.event.getEventCached(this.eventId);
            this.metadata = await this.$services.metadata.getTargetingMetadata(event);

        } catch (error) {
            console.error('[PersonTarget] Could not load metadata', error.message);
            this.metadata = {};
        }

        const fpExtId = 'fp_ext_id';
        this.metadata[fpExtId] = {
            field: fpExtId,
            label: this.$i18n.t('targeting.conditions_editor.fp_ext_id')
        };
        const allFields = this.$utils.metadata.convertMetadataHashToOrderedList(this.metadata);
        if (this.fieldKinds) {
            this.fields = allFields.filter(field => field.kind && this.fieldKinds.includes(field.kind));
        } else {
            this.fields = allFields;
        }
        this.fields.forEach(field => field.name = field.field);

        if (this.additionalFields.length) {
            this.fields.push(...this.additionalFields);
        }
    },

    methods: {
        /**
         * Adds a new rule
         *
         * @public
         */
        addRule() {
            this.$set(this.innerValue, this.innerValue.length, [{ _init: true }]);
        },

        /**
         * Normalizes the predicates configuration
         *
         * @returns {{targets: object[], exceptions: object[]}} the targeting config
         */
        normalizeTargetConfig() {
            const cleanFilter = rule => rule.length;
            const normalized = this.innerValue.filter(cleanFilter);

            const mapper = rule => rule.reduce((accumulator, predicate) => {
                const { name, value } = predicate;
                if (name && typeof value !== 'undefined') {
                    accumulator[name] = value;
                }
                return accumulator;
            }, {});

            return normalized.map(mapper);
        },

        /**
         * Transform normalized targets to predicate form
         *
         * @param {object[]} conditions the condition to un-normalize
         *
         * @returns {{name: string, value: any}[]} the targeting config
         */
        unnormalizeTargetConfig(conditions) {
            if (isEmpty(conditions)) {
                return [];
            }

            const cond = [];
            for (const [index, predicate] of conditions.entries()) {
                const predicates = [];
                for (const key of Object.keys(predicate)) {
                    predicates.push({
                        name: key,
                        value: predicate[key]
                    });
                }

                cond[index] = predicates;
            }

            return cond;
        },

        setValue(value, index) {
            this.$set(this.innerValue, index, value);
            this.$emit('input', this.normalizeTargetConfig());
            this.$emit('change', this.normalizeTargetConfig());
        },

        onChange() {
            this.$emit('change', this.normalizeTargetConfig());
        }
    }
};

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('fieldset',{staticClass:"person-target"},[(_vm.$scopedSlots['header'])?_c('div',{staticClass:"heading"},[_vm._t("header",null,{"values":_vm.innerValue,"addRule":_vm.addRule})],2):_vm._e(),_c('div',{staticClass:"widget"},[_c('div',{staticClass:"rules predicates-editor"},[_vm._l((_vm.innerValue),function(rule,index){return [_c('condition-rule',{attrs:{"value":_vm.innerValue[index],"fields":_vm.fields,"event-id":_vm.eventId},on:{"input":function (value) { return _vm.setValue(value, index); },"change":_vm.onChange}}),(index < _vm.innerValue.length - 1)?_c('span',{staticClass:"separator"},[_vm._v(_vm._s(_vm.$t('base.or')))]):_vm._e()]})],2),(_vm.showActions)?_c('div',{staticClass:"actions"},[_c('a',{staticClass:"has-action",on:{"click":function($event){return _vm.addRule()}}},[_vm._v(_vm._s(_vm.$t('targeting.conditions_editor.add_rule')))])]):_vm._e()])])}
var __vue_staticRenderFns__ = []

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "PersonTarget.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__